<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-field label="Contatti">
          <b-input
            placeholder="Numero di contatti"
            v-model="currentCard.valutations.contacts"
            type="number"
            min="0"
            max="10000"
            expanded
            required
          ></b-input>
        </b-field>

        <b-field label="Degustazioni">
          <b-input
            placeholder="Numero degustazioni (max <= contatti)"
            v-model="currentCard.valutations.tastings"
            type="number"
            min="0"
            :max="currentCard.valutations.contacts"
            expanded
            required
          ></b-input>
        </b-field>

        <b-field label="Affluenza">
          <b-select
            placeholder="Imposta affluenza"
            v-model="currentCard.valutations.affluence"
            expanded
            required
          >
            <option value="1">Bassa</option>
            <option value="2">Media</option>
            <option value="3">Alta</option>
          </b-select>
        </b-field>
      </div>

      <div class="column">
        <b-field label="Reazione dei clienti">
          <b-select
            placeholder="Imposta reazione clienti"
            v-model="currentCard.valutations.customersReactionUsual"
            expanded
            required
          >
            <option value="1">Scarso interesse</option>
            <option value="2">Medio interesse</option>
            <option value="3">Alto interesse</option>
          </b-select>
        </b-field>

        <b-field label="Dettagli reazioni clienti">
          <b-input
            v-model="currentCard.valutations.customerReactions"
            maxlength="600"
            type="textarea"
          ></b-input>
        </b-field>
      </div>

      <div class="column">
        <b-field label="Domande poste dai clienti">
          <b-input
            v-model="currentCard.valutations.customerQuestions"
            maxlength="600"
            type="textarea"
            required
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Attività della concorrenza">
          <b-input
            v-model="currentCard.valutations.competitionActivity"
            maxlength="600"
            type="textarea"
            required
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Osservazioni hostess">
          <b-input
            v-model="currentCard.valutations.hostessNote"
            maxlength="600"
            type="textarea"
            required
          ></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-field label="Leaf consegnati">
          <b-input
            v-model="currentCard.valutations.leafletsDelivered"
            placeholder="Number"
            type="number"
            min="0"
            required
          ></b-input
        ></b-field>
        <div class="columns is-mobile">
          <div class="column">
            Banchetto allestito
            <div class="field">
              <b-switch v-model="currentCard.valutations.banquet"></b-switch>
            </div>
          </div>
          <div class="column">
            Stopper posizionati
            <div class="field">
              <b-switch v-model="currentCard.valutations.stopper"></b-switch>
            </div>
          </div>
        </div>

        <div class="columns is-mobile">
          <div class="column">
            Totem allestito
            <div class="field">
              <b-switch v-model="currentCard.valutations.totem"></b-switch>
            </div>
          </div>
          <div class="column">
            Isola allestita
            <div class="field">
              <b-switch
                v-model="currentCard.valutations.setupIsland"
              ></b-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <b-field label="Altri materiali pop posizionati">
          <b-input
            v-model="currentCard.valutations.popMaterials"
            maxlength="600"
            type="textarea"
            required
          ></b-input>
        </b-field>
      </div>
      <div class="column">
        <OpenSwitch
          label="Posizionamento"
          v-model="currentCard.valutations.placement"
          :options="opendropdownElements"
          required
        ></OpenSwitch>
      </div>
    </div>

    <b-field label="Note">
      <b-input
        v-model="currentCard.valutations.note"
        maxlength="600"
        type="textarea"
        required
      ></b-input>
    </b-field>

    <hr />

    <PromoterCompetitorsContainer
      :currentCard="currentCard"
      v-model="currentCard.competitors"
    />

    <hr />
  </div>
</template>

<script>
import OpenSwitch from "../../components/dropdown/OpenSwitch";
import PromoterCompetitorsContainer from "./Promoters/PromoterCompetitorsContainer";

export default {
  components: {
    OpenSwitch,
    PromoterCompetitorsContainer,
  },
  props: ["currentCard"],
  data() {
    return {
      opendropdownElements: ["CORSIA", "TESTATA", "ISOLA"],
    };
  },
  mounted() {},
  created() {
    if (this.currentCard.competitors == null) this.currentCard.competitors = [];
  },
};
</script>
